<template>
  <div class="filter-condition" v-if="comparators">
    <!-- <pre>{{ inputType }} {{ model.comparator }} {{ fieldType }}</pre> -->
    <flex-row gap vcenter>
      <flex-cell>
        <native-select
          title="Select field"
          v-model="model.key"
          :field="keyField"
        />
      </flex-cell>
      <flex-cell v-if="model.key">
        <native-select
          title="Select comparator"
          v-model="model.comparator"
          :field="comparatorField"
        />
      </flex-cell>
      <flex-cell v-if="model.key && model.comparator">
        <div v-if="inputType == 'array'">
          <template v-if="showSelectOptions">
            <native-select v-model="model.values" :field="multiOptionsField" />
          </template>
          <template v-else>
            <template v-if="fieldWidget == 'currency'">
              <currency-field :field="arrayField" v-model="model.values" />
            </template>
            <template v-else-if="fieldWidget == 'timefield'">
              <timefield :field="arrayField" v-model="model.values" />
            </template>
            <template v-else-if="fieldWidget == 'country'">
              <country-select :field="arrayField" v-model="model.values" />
            </template>
            <template v-else-if="fieldWidget == 'timezone'">
              <timezone-select :field="arrayField" v-model="model.values" />
            </template>
            <text-field v-else :field="arrayField" v-model="model.values" />
          </template>
        </div>
        <div v-if="inputType == 'range'">
          <template v-if="fieldWidget == 'currency'">
            <currency-field :field="normalField" v-model="model.value" />
            And
            <currency-field :field="normalField" v-model="model.value2" />
          </template>
          <template v-else-if="fieldWidget == 'timefield'">
            <time-field :field="normalField" v-model="model.value" />
            And
            <time-field :field="normalField" v-model="model.value2" />
          </template>
          <template v-else>
            <text-field :field="normalField" v-model="model.value" />
            And
            <text-field :field="normalField" v-model="model.value2" />
          </template>
        </div>
        <div v-if="inputType == 'daterelative'">
          <flex-row>
            <flex-cell style="width: 80px">
              <text-field :field="relativeNumberField" v-model="model.value" />
            </flex-cell>
            <flex-cell>
              <native-select
                v-model="model.value2"
                :field="relativePeriodField"
              />
              <!-- <text-field :field="relativePeriodField" v-model="model.value" /> -->
            </flex-cell>
          </flex-row>
        </div>
        <div v-if="inputType == 'daterange'">
          <date-field
            :disableTime="showDateOnly"
            :field="dateField"
            v-model="model.value"
          />
          And
          <date-field
            :disableTime="showDateOnly"
            :field="dateField"
            v-model="model.value2"
          />
        </div>
        <div v-if="inputType == 'date'">
          <date-field
            :disableTime="showDateOnly"
            :field="dateField"
            v-model="model.value"
          />
        </div>
        <div v-if="inputType == 'reference'">
          <template v-if="model.key === 'meta.scopes'">
            <scope-select :maximum="1" v-model="singleValueTransformer" />
          </template>
          <content-select
            v-else
            :field="singleReferenceField"
            v-model="model.value"
          />
        </div>
        <div v-if="inputType == 'multireference'">
          <template v-if="model.key === 'meta.scopes'">
            <scope-select v-model="model.values" />
          </template>
          <content-select
            v-else
            :field="multiReferenceField"
            v-model="model.values"
          />
        </div>
        <div v-if="inputType == 'boolean'">
          <flex-row gap center>
            <flex-cell shrink>
              <ux-switch
                @click="model.value = !model.value"
                :value="model.value"
              />
            </flex-cell>
            <flex-cell>
              {{ model.value ? "True" : "False" }}
            </flex-cell>
          </flex-row>
          <!--  <input type="checkbox" v-model="model.value" /> -->
        </div>
        <div v-if="inputType == 'none'"></div>

        <div v-if="inputType == 'number'">
          <template v-if="fieldWidget == 'currency'">
            <currency-field :field="normalField" v-model="model.value" />
          </template>
          <template v-else-if="fieldWidget == 'timefield'">
            <time-field :field="normalField" v-model="model.value" />
          </template>
          <text-field v-else :field="normalField" v-model="model.value" />
        </div>
        <div v-if="inputType == 'normal'">
          <template v-if="showSelectOptions">
            <native-select v-model="model.value" :field="singleOptionsField" />
          </template>
          <template v-else>
            <template v-if="fieldWidget == 'country'">
              <country-select :field="normalField" v-model="model.value" />
            </template>
            <template v-else-if="fieldWidget == 'timezone'">
              <timezone-select :field="normalField" v-model="model.value" />
            </template>
            <text-field v-else :field="normalField" v-model="model.value" />
          </template>
        </div>
      </flex-cell>
      <flex-cell shrink v-if="enableRemove">
        <ux-button size="sm" icon @click="$emit('remove')">
          <ux-icon icon="fa-times" />
        </ux-button>
      </flex-cell>
    </flex-row>
    <template v-if="extraCriteria">
      <label>Where:</label>
      <div
        :key="condition._guid"
        v-for="(condition, index) in model.conditions"
      >
        <filter-condition
          :enableRemove="true"
          :fields="criteriaFields"
          @remove="removeCondition(index)"
          v-model="model.conditions[index]"
        />
      </div>

      <ux-button size="sm" @click.stop.prevent="addCondition">
        Add Criteria
        <ux-icon icon="fa-plus" right />
      </ux-button>
    </template>
  </div>
</template>
<script>
import additionalProfileFields from "./types/profile.js";
import additionalCheckinFields from "./types/checkin.js";
import additionalAssignmentFields from "./types/assignment.js";
// import additionalSubmissionFields from "./types/submission.js";
// import additionalFilterFields from "./types/all.js";

import DateField from "../form/inputs/datefield.vue";
import TextField from "../form/inputs/textfield.vue";
import CurrencyField from "../form/inputs/currency.vue";
import CountrySelect from "../form/inputs/country.vue";
import TimezoneSelect from "../form/inputs/timezone.vue";
import NativeSelect from "../form/inputs/select.vue";
import ContentSelect from "../form/inputs/content-select.vue";
import ScopeSelect from "../form/inputs/scope-select.vue";
import TimeField from "../form/inputs/timefield.vue";
export default {
  emits: ["remove"],
  props: {
    fields: {
      type: Array,
      default() {
        return [];
      },
    },
    enableRemove: {
      type: Boolean,
    },
    modelValue: {
      type: Object,
      default() {
        return {
          key: "",
          comparator: "",
          value: null,
          value2: null,
          values: [],
          conditions: [],
        };
      },
    },
  },
  async created() {
    this.comparators = await this.$sdk.content.comparators();
    this.glossary = await this.$sdk.content.glossary({ hash: true });
  },
  data() {
    return {
      comparators: null,
      model: this.modelValue,
      criteriaFields: [],
      glossary: {},
    };
  },
  watch: {
    field: {
      immediate: true,
      handler(field) {
        if (field && field.translationDisabled) {
          this.model.translationDisabled = true;
        } else {
          delete this.model.translationDisabled;
        }
      },
    },
    useTime(t) {
      if (t) {
        if (!this.model.options) {
          this.model.options = {};
        }

        this.model.options.useTime = true;
      } else {
        if (!this.model.options) {
          return;
        }

        delete this.model.options.useTime;
      }
    },
    modelValue(m) {
      if (m != this.model) {
        this.model = m;
      }
    },
    fieldType(newVal, old) {
      if (old) {
        this.model.comparator = undefined;
      }
    },
    modelKey: {
      handler(key, previousKey) {
        const field = this.field;
        if (!previousKey && key) {
          // If there is actually a field
          if (field) {
            switch (key) {
              case "_dob":
                this.model.comparator = "anniversarybetween";
                return;
              case "_age":
                this.model.comparator = "between";
                return;
            }

            // Pick an appropriate default comparator
            switch (field.type) {
              case "date":
                this.model.comparator = "datebetween";
                break;
              case "number":
              case "integer":
              case "decimal":
              case "float":
                this.model.comparator = "equal";
                break;
              default:
                switch (field.widget) {
                  case "timezone":
                  case "country":
                    this.model.comparator = "equal";
                    break;
                  default:
                    this.model.comparator = "in";
                    break;
                }

                break;
            }

            if (this.extraCriteria) {
              var first = (field.titles || [])[1];
              this.model.title = `Filter (${first || field.title})`;
            } else {
              this.model.title = `Filter (${field.title})`;
            }

            this.model.type = field.type;
          }
        }

        if (previousKey && field) {
          this.model.value = undefined;
          this.model.value2 = undefined;
          this.model.values = [];
        }
      },
    },
    checkCriteriaType: {
      immediate: true,
      async handler() {
        const self = this;
        const bool = self.extraCriteria;

        let criteriaFields = [];

        if (bool) {
          self.glossary = await self.$sdk.content.glossary({ hash: true });
          const glossary = self.glossary;
          const referenceType = self.field?.referenceType;

          let matchedReference = glossary[referenceType];

          if (matchedReference) {
            let matchedTypeFields = matchedReference.fields || [];
            let additionalFields = [];

            switch (referenceType) {
              case "assignment":
                additionalFields = additionalAssignmentFields(self);
                break;
              case "checkin":
                additionalFields = additionalCheckinFields(self);
                break;
            }

            matchedTypeFields = [...matchedTypeFields, ...additionalFields];

            const cleanedBasicFields = matchedTypeFields.filter(
              function (field) {
                switch (field.key) {
                  case "organisation":
                  case "reference":
                  case "referenceType":
                    return false;
                }

                return true;
              },
            );

            criteriaFields = [
              ...cleanedBasicFields,
              {
                title: "",
                key: "data",
                type: "group",
                asObject: true,
                minimum: 1,
                maximum: 1,
                fields: [...(matchedReference.definedFields || [])],
              },
            ];
          }

          // Map the fields
          criteriaFields = self.$sdk.utils.mapFields(criteriaFields, {
            includeArrayDelimeter: true,
          });

          switch (referenceType) {
            case "stat":
              criteriaFields = [
                {
                  title: "User",
                  key: "p",
                  minimum: 1,
                  maximum: 0,
                  type: "reference",
                  referenceType: "persona",
                },
                {
                  title: "Reaction",
                  key: "k",
                  minimum: 1,
                  maximum: 0,
                  type: "string",
                  widget: "select",
                  options: [
                    {
                      title: "Like",
                      value: "_like",
                    },
                    {
                      title: "Dislike",
                      value: "_dislike",
                    },

                    {
                      title: "Upvote",
                      value: "_upvote",
                    },
                    {
                      title: "Downvote",
                      value: "_downvote",
                    },
                    {
                      title: "Subscribe",
                      value: "_subscribe",
                    },
                    {
                      title: "Unsubscribe",
                      value: "_unsubscribe",
                    },
                  ],
                },
              ];
              break;
            case "blockout":
              criteriaFields = [
                {
                  title: "Start",
                  key: "startDate",
                  type: "date",
                  minimum: 0,
                  maximum: 1,
                },
                {
                  title: "End",
                  key: "endDate",
                  type: "date",
                  minimum: 0,
                  maximum: 1,
                },
                {
                  title: "Reason / Title",
                  key: "title",
                  type: "string",
                  minimum: 0,
                  maximum: 1,
                },
              ];

              break;
          }

          self.model.renderer = "complex";
        } else {
          if (self.model.renderer === "complex") {
            self.model.renderer = undefined;
          }
        }

        self.criteriaFields = criteriaFields;
      },
    },
  },
  computed: {
    checkCriteriaType() {
      return [this.extraCriteria, this.referenceType];
    },
    modelKey() {
      return this.model.key;
    },
    useTime() {
      switch (this.model.type) {
        case "date":
        case "daterange":
          if (!this.showDateOnly) {
            return true;
          }
          break;
      }

      return undefined;
    },
    singleValueTransformer: {
      get() {
        return [this.model.value].filter(Boolean);
      },
      set(v) {
        this.model.value = v[0];
      },
    },
    extraCriteria() {
      return (
        this.field &&
        this.field.path &&
        this.field.path.startsWith("join_") &&
        this.field.path.endsWith(".total")
      );
    },
    showSelectOptions() {
      if (!this.hasOptions) {
        return false;
      }
      if (this.comparator?.freeform) {
        return false;
      }

      return true;
    },
    hasOptions() {
      return !!(this.field && this.field.options && this.field.options.length);
    },
    fieldHash() {
      return this.fields.reduce(function (set, field) {
        set[field.path || field.key] = field;
        return set;
      }, {});
    },
    keyOptions() {
      const self = this;

      return self.fields.reduce(function (memo, entry, index) {
        switch (entry.type) {
          case "object":
          case "group":
            break;
          default:
            let title = entry.title;

            if (entry.filterTitle) {
              title = entry.filterTitle;
            } else {
              if (entry.titles && entry.titles.length) {
                title = entry.titles.filter(Boolean).join(" › ");
              }
            }

            if (!entry.filterDisabled) {
              const output = {
                title,
                value: entry.path || entry.key,
              };

              memo.push(output);
            }
            break;
        }

        return memo;
      }, []);
    },

    keyField() {
      return {
        minimum: 1,
        maximum: 1,
        options: this.keyOptions,
        sorted: true,
      };
    },
    field() {
      return this.fieldHash[this.model.key];
    },
    fieldWidget() {
      if (this.comparator?.inputWidget) {
        return this.comparator.inputWidget;
      }

      switch (this.field?.widget) {
        case "country":
        case "timezone":
        case "currency":
        case "timefield":
          return this.field.widget;
      }
    },
    fieldType() {
      if (!this.field) {
        return;
      }

      return this.field.type;
    },
    inputType() {
      if (!this.comparator) {
        return;
      }

      var inputType = this.comparator.inputType;

      switch (inputType) {
        case "none":
        case "range":
        case "daterange":
        case "daterelative":

        // If it's specified it's a number
        case "integer":
        case "decimal":
        case "float":
        case "number":
          // Keep it the same as specified
          break;
        case "array":
          switch (this.fieldType) {
            case "reference":
              inputType = "multireference";
              break;
          }
          break;
        default:
          inputType = "normal";
          switch (this.fieldType) {
            case "reference":
            case "boolean":
            case "date":
              inputType = this.fieldType;
              break;
            case "integer":
            case "decimal":
            case "float":
            case "number":
              inputType = "number";
              break;
          }
          break;
      }

      return inputType;
    },
    comparator() {
      return this.comparatorLookup[this.model.comparator];
    },
    comparatorLookup() {
      return this.comparators.hash;
    },
    comparatorOptions() {
      const self = this;

      if (!self.fieldType) {
        return [];
      }

      var relevantComparators =
        self.comparators.available[self.fieldType] || [];
      var options = relevantComparators
        .filter(function (option) {
          if (option.restrictKey) {
            return option.restrictKey.includes(self.model.key);
          }

          if (option.multipleOnly) {
            if (self.field.maximum === 1) {
              return false;
            }
          }

          return true;
        })
        .map(function (entry) {
          return {
            title: entry.title,
            value: entry.operator,
          };
        });

      return options;
    },

    comparatorField() {
      return {
        minimum: 1,
        maximum: 1,
        options: this.comparatorOptions,
      };
    },
    referenceType() {
      if (!this.field) {
        return;
      }

      return this.field.referenceType;
    },
    relativeNumberField() {
      return {
        type: "integer",
        maximum: 1,
        minimum: 1,
        placeholder: "0",
      };
    },
    relativePeriodField() {
      return {
        type: "string",
        maximum: 1,
        minimum: 1,
        widget: "select",

        options: [
          {
            title: "Minutes",
            value: "minutes",
          },
          {
            title: "Hours",
            value: "hours",
          },
          {
            title: "Days",
            value: "days",
          },
          {
            title: "Weeks",
            value: "weeks",
          },
          {
            title: "Months",
            value: "months",
          },
          {
            title: "Years",
            value: "years",
          },
        ],
      };
    },
    inputPlaceholder() {
      switch (this.model.comparator) {
        case "valuesgreater":
        case "valuesgreaterequal":
        case "valueslesser":
        case "valueslesserequal":
          return "0";
          break;
      }
      return this.field?.title;
    },
    showDateOnly() {
      switch (this.model.comparator) {
        case "dateanniversary":
        case "anniversarybetween":
        case "datesameday":
        case "datesamemonth":
        case "datesameweek":
        case "datesameyear":
          return true;
      }

      const specifiedOnField = !!this.field?.dateOnly;
      if (specifiedOnField) {
        return true;
      }

      // If it specifically is configured on
      // the field to enable the time picker
      if (!!this.field?.filterIncludeTime) {
        return false;
      }

      // Default to normalising the date picker
      // to ignore time of day
      return true;
    },
    dateField() {
      return {
        type: this.fieldType,
        maximum: 1,
        minimum: 1,
        placeholder: this.inputPlaceholder,
        dateOnly: this.showDateOnly,
      };
    },
    multiOptionsField() {
      return {
        // title:`Select ${this.field.title}`,
        options: this.field.options,
        widget: "select",

        type: this.fieldType,
        maximum: 0,
        minimum: 1,
        placeholder: this.inputPlaceholder,
        sorted: true,
      };
    },
    singleOptionsField() {
      return {
        title: "", //`Select ${this.field.title}`,
        options: this.field.options,
        widget: "select",

        type: this.fieldType,
        maximum: 1,
        minimum: 0,
        placeholder: this.inputPlaceholder,
        sorted: true,
      };
    },
    normalField() {
      const settings = {};
      const extras = {};
      extras.currency = this.field?.currency;
      extras.syntax = this.field?.syntax;

      return Object.assign(
        settings,
        {
          type: this.fieldType,

          maximum: 1,
          minimum: 1,
          placeholder: this.inputPlaceholder,
          widget: this.fieldWidget,
        },
        extras,
      );
    },
    arrayField() {
      return {
        title: this.field?.title,
        hideTitle: true,
        type: this.fieldType,
        maximum: 0,
        minimum: 1,
      };
    },
    singleReferenceField() {
      return {
        type: "reference",

        referenceType: this.referenceType,
        maximum: 1,
        minimum: 1,
        create: false,
        list: false,
      };
    },
    multiReferenceField() {
      return {
        type: "reference",

        referenceType: this.referenceType,
        maximum: 0,
        minimum: 1,
        create: false,
        list: false,
      };
    },
  },
  methods: {
    addCondition() {
      if (!this.model.conditions) {
        this.model.conditions = [];
      }
      this.model.conditions.push({
        _guid: Math.random(),
      });
    },
    removeCondition(index) {
      this.model.conditions.splice(index, 1);
    },
  },

  components: {
    TextField,
    CurrencyField,
    TimeField,
    DateField,
    NativeSelect,
    ContentSelect,
    ScopeSelect,
    CountrySelect,
    TimezoneSelect,
  },
};
</script>
<style scoped lang="scss">
.filter-condition {
  padding: 0.2em;
  border-radius: 0.3em;
  background: var(--bg1, #fff);
  border: 1px solid rgba(#000, 0.1);
  margin: 0.2em 0.5em;
}

label {
  display: block;
  text-transform: uppercase;
  font-weight: 500;
  opacity: 0.5;
  font-size: 0.7em;
  margin-top: 0.2em;
}
</style>
